// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCR3WuqMDKQt_9ZsH5kyI7CzPV9XPWKEOY",
  authDomain: "chatapp-f956f.firebaseapp.com",
  projectId: "chatapp-f956f",
  storageBucket: "chatapp-f956f.appspot.com",
  messagingSenderId: "1001676371739",
  appId: "1:1001676371739:web:a571dd504641cdafc685be"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export default firebaseConfig